import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Store from "@/store";
import common from "@/services/common.service";

import Shop from "@/views/shop/Shop.vue";
import Client from "@/views/user/User.vue";
import Auth from "@/views/auth/Auth.vue";
import Help from "@/views/help/Help.vue";
import Files from "@/views/files/Files.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/shop",
    name: "shop",
    component: Shop,
    meta: {
      requiresAuth: true,
      role: "ROLE_USER"
    },
    children: [
      {
        path: "/new-client",
        name: "new-client",
        component: () => import("../views/shop/NewClient.vue"),
        meta: {
          requiresAuth: true,
          role: "ROLE_USER"
        }
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("../views/shop/Profile.vue"),
        meta: {
          requiresAuth: true,
          role: "ROLE_USER"
        }
      },
      {
        path: "/offer",
        name: "offer",
        component: () => import("../views/shop/Offer.vue"),
        meta: {
          requiresAuth: true,
          role: "ROLE_USER"
        }
      },
      {
        path: "/contract",
        name: "contract",
        component: () => import("../views/shop/Contract.vue"),
        meta: {
          requiresAuth: true,
          role: "ROLE_USER"
        }
      }
    ]
  },
  {
    path: "/user",
    name: "user",
    component: Client,
    meta: {
      requiresAuth: true,
      role: "ROLE_ADMIN"
    }
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: {
      requiresAuth: true,
      role: "ROLE_USER"
    }
  },
  {
    path: "/new-user/:id",
    name: "new-user",
    component: () => import("../views/user/NewUser.vue"),
    meta: {
      requiresAuth: true,
      role: "ROLE_ADMIN"
    }
  },
  {
    path: "/admin-password",
    name: "admin-password",
    component: () => import("../views/user/AdminPassword.vue"),
    meta: {
      requiresAuth: true,
      role: "ROLE_ADMIN"
    }
  },
  {
    path: "/files",
    name: "files",
    component: Files,
    meta: {
      requiresAuth: true,
      role: "ROLE_ADMIN"
    }
  },
  {
    path: "/contracts/",
    name: "contracts",
    component: () => import("../views/contracts/Contracts.vue"),
    meta: {
      requiresAuth: true,
      role: "ROLE_ADMIN"
    }
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth,
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/auth/Login.vue")
      },
      {
        path: "/recover-password",
        name: "recover",
        component: () => import("../views/auth/Recover.vue")
      }
    ]
  },
  {
    path: "*",
    name: "index",
    redirect: "login"
  }
];

const router = new VueRouter({
  routes,
  base: process.env.VUE_APP_BASE
});

router.beforeEach((to, from, next) => {
  const role = Store.getters.getUserLogged
    ? Store.getters.getUserLogged.role
    : null;
  const allowedRoles = to.matched.reduce((acc, route) => {
    return route.meta.role && !acc.length ? route.meta.role : acc;
  }, []);
  if (
    !to.matched.some(record => record.meta.requiresAuth) ||
    (Store.getters.getUserLogged &&
      to.matched.some(record => record.meta.role) &&
      common.ifArrayIsInArray(allowedRoles, role))
  ) {
    if (to.name === "login" && localStorage.getItem("token")) {
      next({ name: "new-client" });
    } else {
      next();
    }
  } else {
    next({ name: "login" });
  }
});

export default router;
